"use strict";

/**
 * @type Controller
 * @name printDialogCtrl
 * @packageName print_dialog_ctrl.js
 *
 * @description PrintDialog
 *
 *
 */
class printDialogCtrl {

    constructor($scope, $mdDialog, $http, moment, urlData) {
        this.$mdDialog = $mdDialog;
        this.$http = $http;
        this.$moment = moment;

        $scope.close = () => {
            this.close();
        };

        this.data = null;
        this.dayData = {};

        let url = '/station';
        this.$http.get(url).then((stationresponse) => {
            let url = '/broadcasts/week/' + urlData;

            this.$http.get(url).then((response) => {
                this.data = response.data;
                console.log(this.data);
                this.dayData['days'] = {};

                for (let day in this.data.days) {
                    let broadcasts = this.data.days[day].broadcasts;
                    var lastBroadcast = null;
                    var addData;
                    var addPageData = [];
                    this.dayData['days'][day] = [];
                    this.dayData['start'] = this.data.start;
                    this.dayData['stop'] = this.data.stop;
                    for (let id in broadcasts) {

                        let broadcast = this.data.days[day].broadcasts[id];

                        if (lastBroadcast && (lastBroadcast.stop > broadcast.start)) {

                            addData.push(broadcast);
                        } else {

                            if (addData) {
                                this.splitInPages(addData, day);
                                addData = null;
                            }

                            addData = [broadcast];
                        }

                        if (!lastBroadcast || lastBroadcast.stop < broadcast.stop) {
                            lastBroadcast = broadcast;
                        }
                    }

                    if (addData) {

                        this.splitInPages(addData, day);
                        addData = null;
                    }
                }

                let days = Object.keys(this.dayData.days);
                this.generatePage({
                    title: stationresponse.data.name + ' | Week ' + this.$moment().format("WW"),
                    days: days
                });
            });

        });

        this.$http.get('/station/masterstations').then((stations) => {
            this.masterstations = stations.data;
        });

    }

    splitInPages(addData, day) {

        let StartPageNr = Math.floor(new this.$moment.tz(addData[0].start, window.CONFIG.timezone).hour() / 8);
        let StopPageNr = Math.floor(new this.$moment.tz(addData[0].stop, window.CONFIG.timezone).hour() / 8);
        StopPageNr = (StopPageNr < StartPageNr) ? 2 : StopPageNr;

        let newArray = [];

        let index = StartPageNr;
        let pages = (StopPageNr - StartPageNr);

        for (let i = 0; i < (pages + 1); i++) {

            let newAddDataArray = [];

            for (let ii = 0; ii < addData.length; ii++) {

                let newObj = Object.assign({}, addData[ii]);
                let bcStartPageNr = Math.floor(new this.$moment.tz(newObj.start, window.CONFIG.timezone).hour() / 8);
                let bcStopPageNr = Math.floor(new this.$moment.tz(newObj.stop, window.CONFIG.timezone).hour() / 8);
                bcStopPageNr = (bcStopPageNr < bcStartPageNr) ? 2 : bcStopPageNr;

                let bcPages = (bcStopPageNr - bcStartPageNr);

                if (index === 0 && bcPages > 0) {

                    newObj.stop = this.getNewDatetimeString(newObj.stop, 8);
                } else if (index === 1 && bcPages > 0 && bcStartPageNr !== 1) {

                    newObj.start = this.getNewDatetimeString(newObj.start, 8);

                    if (bcPages == 2) {
                        newObj.stop = this.getNewDatetimeString(newObj.stop, 16);
                    }

                    if (Date.parse(newObj.start) == Date.parse(newObj.stop)) {
                        continue;
                    }

                } else if (index === 1 && bcPages > 0 && bcStartPageNr === 1) {

                    newObj.stop = this.getNewDatetimeString(newObj.stop, 16);
                } else if (index === 2 && bcPages > 0) {

                    newObj.start = this.getNewDatetimeString(newObj.start, 16);
                }

                if (index < bcStartPageNr || index > bcStopPageNr || ( Date.parse(newObj.start) == Date.parse(newObj.stop) )) {

                    newObj = null;
                }
                newAddDataArray.push(newObj);
            }

            this.dayData['days'][day][index] = this.dayData['days'][day][index] || [];
            this.dayData['days'][day][index].push(newAddDataArray);

            index++
        }
    }

    getNewDatetimeString(datetimeStr, hour) {

        let datetimeObj = new this.$moment.tz(datetimeStr, window.CONFIG.timezone);
        datetimeObj.hour(hour);
        datetimeObj.minutes(0);
        return datetimeObj.format();
        
    }

    close() {
        this.$mdDialog.hide();
    }

    setGrid(doc, pageNr = 1) {

        console.log(this.dayData);

        let minute = 1.0;

        doc.fontSize(14)
            .text(doc.info.title, 40, 20, {align: 'center'});

        for (let i = 0; i < 9; i++) {

            let hour = i + ((pageNr - 1) * 8);
            let hourText = (hour < 10) ? '0' + hour : hour;
            hourText = (hour == 24) ? '00' : hour;

            let topText = 67 + (i * 60);

            doc.font('Helvetica')
                .fill('#828282')
                .fontSize(12)
                .text(hourText + ':00', 0, topText, {align: 'center', width: 148, height: 20});
        }

        for (let i = 0; i < 7; i++) {

            let width = 98.84;
            let left = 110 + (i * width);

            doc.fill('#828282')
                .fontSize(12)
                .text(doc.info.days[i], left, 45, {align: 'center', width: (width - 20), height: 20});
        }

        let prohibition = {
            min: Number(8 * (pageNr - 1)),
            max: Number(8 * pageNr),
            max_height: 480
        };

        let index = 0;
        for (let day in this.dayData.days) {

            let broadcasts = this.dayData.days[day][pageNr - 1];
            let width = 98.84;


            if (!broadcasts || broadcasts.length < 1) {
                index++;
                continue
            }


            for (let i = 0; i < broadcasts.length; i++) {

                if (!broadcasts[i]) {
                    continue;
                }

                let divider = broadcasts[i].length;

                for (let ii = 0; ii < divider; ii++) {

                    if (!broadcasts[i][ii]) {
                        continue;
                    }

                    let starttime = new this.$moment.tz(broadcasts[i][ii].start, window.CONFIG.timezone);
                    starttime = (starttime.hour() * 60) + starttime.minutes();
                    let stoptime = new this.$moment.tz(broadcasts[i][ii].stop, window.CONFIG.timezone);
                    stoptime = (stoptime.hour()) * 60 + stoptime.minutes();
                    stoptime = stoptime === 0 ? (24 * 60) : stoptime;

                    let duration = stoptime - starttime;
                    let broadcastWidth = width / divider;
                    let hour = (new this.$moment.tz(broadcasts[i][ii].start, window.CONFIG.timezone).hour() * 60) - ((pageNr - 1) * 8 * 60);
                    let minute = new this.$moment.tz(broadcasts[i][ii].start, window.CONFIG.timezone).minutes();
                    let left = 100 + ((index * width) + (ii * broadcastWidth));
                    let height = duration;
                    let presenters = [];
                    let margins = 5;
                    

                    for (let presenterIndex in broadcasts[i][ii].presenters) {
                        presenters.push(broadcasts[i][ii].presenters[presenterIndex].name);
                    }

                    doc.roundedRect((left), (hour + minute + 65), (broadcastWidth - 1), (height - 1), 5);

                    let color;
                    let title;

                    if (broadcasts[i][ii].model_type) {
                        color = broadcasts[i][ii].model_type.options.color;
                    } else {
                        color = '#888888';
                    }

                    if(broadcasts[i][ii].station_id){
                        title = this.masterstations[broadcasts[i][ii].station_id];
                    } else {
                        title = broadcasts[i][ii].title || 'Untitled';
                    }

                    doc.fill(color);

                    doc.font('Helvetica')
                        .fill('#ffffff')
                        .fontSize(10)
                        .text(
                            (title),
                            (margins + left),
                            (margins + (hour + minute + 65)),
                            {
                                width: (broadcastWidth - (margins * 2)),
                                height: (height - (margins * 2)),
                                lineGap: 0
                            }
                        );

                    if (doc.y < (margins + (hour + minute + 65)) + (height - (margins * 4))) {
                        doc.moveDown(0.1);
                        doc.font('Helvetica-Oblique')
                            .fill('#ffffff')
                            .fontSize(8)
                            .text(presenters.join(', '), {
                                width: (broadcastWidth - (margins * 2)),
                                height: (height - (margins * 2))
                            });
                    }

                    if (divider > 1) {
                        doc.roundedRect((left), (hour + minute + 65), (broadcastWidth - 1), 5, 5);
                        doc.fill('#ff0000');
                    }
                }
            }
            index++;
        }

        doc.fontSize(14)
            .fill('#000000')
            .fontSize(10)
            .text('Pluxbox Radiomanager', 50, 570, {align: 'left', width: 741.89, height: 20});

        doc.fontSize(14)
            .fill('#000000')
            .fontSize(10)
            .text('Page ' + pageNr + '/3', 50, 570, {align: 'right', width: 741.89, height: 20});
    }

    // generatePage(info) {
    //
    //     let doc = new PDFDocument({
    //         info: info,
    //         layout: 'landscape',
    //         size: 'A4',
    //         margin: {
    //             top: 50,
    //             bottom: 0,
    //             left: 50,
    //             right: 50
    //         }
    //     });
    //
    //     this.setGrid(doc, 1);
    //
    //     doc.addPage();
    //     this.setGrid(doc, 2);
    //
    //     doc.addPage();
    //     this.setGrid(doc, 3);
    //
    //     // pipe the document to a blob
    //     let stream = doc.pipe(blobStream());
    //
    //     doc.end();
    //
    //     stream.on('finish', () => {
    //
    //         // get a blob you can do whatever you like with
    //         let blob = stream.toBlob('application/pdf');
    //
    //         //or get a blob URL for display in the browser
    //         let url = stream.toBlobURL('application/pdf');
    //         document.querySelector('#pdfkit').src = url;
    //
    //         setTimeout(function () {
    //             document.querySelector('#pdfkit').contentWindow.print();
    //         }, 100);
    //     });
    // }
}


/*
 * Inject dependicies
 */
printDialogCtrl.$inject = ['$scope', '$mdDialog', '$http', 'moment', 'urlData', '$timeout'];


/*
 * Browsify connection: execute controller
 */
module.exports = printDialogCtrl;
